import React from 'react';
import { CtaButton } from './CtaButton';
export function Hero() {
  return <header className="w-full border-b border-ink-line bg-cream" data-id="element-41" data-mp="ejwk9bk3of7b">
      <div className="mx-auto grid max-w-5xl grid-cols-1 gap-14 px-6 pb-20 pt-16 md:pb-28 md:pt-24 lg:grid-cols-12 lg:gap-16" data-id="element-42" data-mp="eilgvcukh9gq">
        <div className="lg:col-span-7" data-id="element-43" data-mp="4lqjwydxzh4k">
          <h1 className="font-serif text-[2.75rem] leading-[1.02] text-ink sm:text-6xl lg:text-[4.25rem]" data-id="element-44" data-mp="4mrteyfb7vk6">
            A los 52 años aprendí IA y cambió todo.
            <span className="mt-3 block text-terracotta" data-id="element-45" data-mp="xae74zi94gkr">
              Ahora quiero que tú también lo hagas.
            </span>
          </h1>

          <p className="mt-8 max-w-md text-lg leading-relaxed text-ink-soft md:text-xl" data-id="element-46" data-mp="s9zybf8tt2lo">
            Sin mentiras. Sin promesas falsas.
            <br data-id="element-47" data-mp="neknkw647mth" />
            Solo 3 PDFs con lo que realmente funciona.
          </p>
        </div>

        <div className="lg:col-span-5 lg:pt-4" data-id="element-48" data-mp="3cz5u28857tyr">
          <div className="border-t-2 border-ink pt-6" data-id="element-49" data-mp="381e3bhj8idw5">
            <div className="flex items-end gap-4" data-id="element-50" data-mp="384s3cj4feb0f">
              <span className="font-serif text-7xl leading-none text-ink md:text-8xl" data-id="element-51" data-mp="3j9u1d0dmvqmc">$20</span>
              <span className="pb-2 text-sm font-medium uppercase tracking-wide text-ink-faint" data-id="element-52" data-mp="3o6kdjcmbi22h">
                USD
              </span>
            </div>
            <p className="mt-4 text-base text-ink-soft" data-id="element-53" data-mp="3e9fq79gqk0k3">
              Otros cursos: <span className="line-through decoration-terracotta" data-id="element-54" data-mp="3e7l802wummjp">$97–$200</span>
            </p>

            <div className="mt-8" data-id="element-55" data-mp="30gq5r9guv3p3">
              <CtaButton label="Acceso inmediato por $20" size="lg" fullWidth data-id="element-56" data-mp="358hmksa7lv21" />
            </div>

            <p className="mt-4 text-sm text-ink-faint" data-id="element-57" data-mp="2qk3kijkmaamj">
              Descarga inmediata · Garantía de 7 días
            </p>
          </div>
        </div>
      </div>
    </header>;
}